// extracted by mini-css-extract-plugin
module.exports = {"naBadge":"QuestionResults_naBadge__tOEsB","naCount":"QuestionResults_naCount__2onOG"};